import { AssistantChatKind } from 'shared/domains/apollo/generated/types';
import { ApprovalWorkflowContent } from './ApprovalWorkflowContent';
import { MarkdownContent } from './MarkdownContent';
import { TabularContent } from './TabularContent';
export function PromptRenderer(props) {
    const { prompt } = props;
    const { kind, content } = prompt;
    if (kind === AssistantChatKind.Regular) {
        return <MarkdownContent content={content}/>;
    }
    if (kind === AssistantChatKind.Tabular) {
        return <TabularContent content={content}/>;
    }
    if (kind === AssistantChatKind.ApprovalWorkflow) {
        return <ApprovalWorkflowContent content={content}/>;
    }
    return null;
}
